// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-ChatFilterPanels-module__messagePanelContainer-H280X {
  display: grid;
  align-items: center;
  justify-items: center;
  place-items: center;
  position: relative;
  width: 100%;
}

.nightbot-ChatFilterPanels-module__chatterContainerPositive-bYSvE .nightbot-ChatFilterPanels-module__chatterAvatar-kg2f9 {
    background-color: var(--mantine-color-green-5);
    color: var(--mantine-color-green-1);
  }

.nightbot-ChatFilterPanels-module__chatterContainerPositive-bYSvE .nightbot-ChatFilterPanels-module__chatterScanIcon-NIzGk {
    color: var(--mantine-color-green-5);
  }

.nightbot-ChatFilterPanels-module__chatterContainerNegative-c1QG2 .nightbot-ChatFilterPanels-module__chatterAvatar-kg2f9 {
    background-color: var(--mantine-color-red-5);
    color: var(--mantine-color-red-1);
  }

.nightbot-ChatFilterPanels-module__chatterContainerNegative-c1QG2 .nightbot-ChatFilterPanels-module__chatterScanIcon-NIzGk,.nightbot-ChatFilterPanels-module__chatterContainerNegative-c1QG2 .nightbot-ChatFilterPanels-module__badPhrase-p47OS {
    color: var(--mantine-color-red-5);
  }

.nightbot-ChatFilterPanels-module__chatterAvatar-kg2f9 {
  width: 32px;
  height: 32px;
  color: var(--mantine-color-gray-5);
}

@supports ((-webkit-mask-image: paint(squircle)) or (mask-image: paint(squircle))) {

.nightbot-ChatFilterPanels-module__chatterAvatar-kg2f9 {
    --squircle-smooth: 1;
    --squircle-radius: 96px;
    -webkit-mask-image: paint(squircle);
            mask-image: paint(squircle);
}
  }

.nightbot-ChatFilterPanels-module__chatterScanIcon-NIzGk {
  color: var(--mantine-color-gray-5);
}

.nightbot-ChatFilterPanels-module__badPhrase-p47OS {
  color: inherit;
}

.nightbot-ChatFilterPanels-module__chatterScanIcon-NIzGk,
.nightbot-ChatFilterPanels-module__badPhrase-p47OS,
.nightbot-ChatFilterPanels-module__chatterAvatar-kg2f9 {
  transition-property: background-color, color;
  transition-duration: 500ms;
  transition-timing-function: ease-in-out;
  transition-delay: 1200ms;
}

.nightbot-ChatFilterPanels-module__chatterContainer-h_EuB {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: var(--mantine-radius-xl);
  background-color: var(--mantine-color-gray-1);
}

@supports ((-webkit-mask-image: paint(squircle)) or (mask-image: paint(squircle))) {

.nightbot-ChatFilterPanels-module__chatterContainer-h_EuB {
    --squircle-smooth: 1;
    --squircle-radius: 96px;
    -webkit-mask-image: paint(squircle);
            mask-image: paint(squircle);
}
  }

.nightbot-ChatFilterPanels-module__chatterInfo-H111x {
  display: flex;
  margin-left: 12px;
  flex-direction: column;
  color: var(--mantine-color-gray-9);
  margin-right: auto;
}

.nightbot-ChatFilterPanels-module__message-r9Iee {
  color: var(--mantine-color-gray-7);
}
`, "",{"version":3,"sources":["webpack://./src/components/landing/ChatFilterPanels.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EAAnB,qBAAmB;EAAnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAGE;IACE,8CAA8C;IAC9C,mCAAmC;EACrC;;AAEA;IACE,mCAAmC;EACrC;;AAIA;IACE,4CAA4C;IAC5C,iCAAiC;EACnC;;AAEA;IAEE,iCAAiC;EACnC;;AAGF;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;AAOpC;;AALE;;AALF;IAMI,oBAAoB;IACpB,uBAAuB;IACvB,mCAA2B;YAA3B,2BAA2B;AAE/B;EADE;;AAGF;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,4CAA4C;EAC5C,0BAA0B;EAC1B,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,6CAA6C;AAO/C;;AALE;;AAPF;IAQI,oBAAoB;IACpB,uBAAuB;IACvB,mCAA2B;YAA3B,2BAA2B;AAE/B;EADE;;AAGF;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".messagePanelContainer {\n  display: grid;\n  place-items: center;\n  position: relative;\n  width: 100%;\n}\n\n.chatterContainerPositive {\n  .chatterAvatar {\n    background-color: var(--mantine-color-green-5);\n    color: var(--mantine-color-green-1);\n  }\n\n  .chatterScanIcon {\n    color: var(--mantine-color-green-5);\n  }\n}\n\n.chatterContainerNegative {\n  .chatterAvatar {\n    background-color: var(--mantine-color-red-5);\n    color: var(--mantine-color-red-1);\n  }\n\n  .chatterScanIcon,\n  .badPhrase {\n    color: var(--mantine-color-red-5);\n  }\n}\n\n.chatterAvatar {\n  width: 32px;\n  height: 32px;\n  color: var(--mantine-color-gray-5);\n\n  @supports (mask-image: paint(squircle)) {\n    --squircle-smooth: 1;\n    --squircle-radius: 96px;\n    mask-image: paint(squircle);\n  }\n}\n\n.chatterScanIcon {\n  color: var(--mantine-color-gray-5);\n}\n\n.badPhrase {\n  color: inherit;\n}\n\n.chatterScanIcon,\n.badPhrase,\n.chatterAvatar {\n  transition-property: background-color, color;\n  transition-duration: 500ms;\n  transition-timing-function: ease-in-out;\n  transition-delay: 1200ms;\n}\n\n.chatterContainer {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  border-radius: var(--mantine-radius-xl);\n  background-color: var(--mantine-color-gray-1);\n\n  @supports (mask-image: paint(squircle)) {\n    --squircle-smooth: 1;\n    --squircle-radius: 96px;\n    mask-image: paint(squircle);\n  }\n}\n\n.chatterInfo {\n  display: flex;\n  margin-left: 12px;\n  flex-direction: column;\n  color: var(--mantine-color-gray-9);\n  margin-right: auto;\n}\n\n.message {\n  color: var(--mantine-color-gray-7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messagePanelContainer": `nightbot-ChatFilterPanels-module__messagePanelContainer-H280X`,
	"chatterContainerPositive": `nightbot-ChatFilterPanels-module__chatterContainerPositive-bYSvE`,
	"chatterAvatar": `nightbot-ChatFilterPanels-module__chatterAvatar-kg2f9`,
	"chatterScanIcon": `nightbot-ChatFilterPanels-module__chatterScanIcon-NIzGk`,
	"chatterContainerNegative": `nightbot-ChatFilterPanels-module__chatterContainerNegative-c1QG2`,
	"badPhrase": `nightbot-ChatFilterPanels-module__badPhrase-p47OS`,
	"chatterContainer": `nightbot-ChatFilterPanels-module__chatterContainer-h_EuB`,
	"chatterInfo": `nightbot-ChatFilterPanels-module__chatterInfo-H111x`,
	"message": `nightbot-ChatFilterPanels-module__message-r9Iee`
};
export default ___CSS_LOADER_EXPORT___;
